/**
 * Category Collapse — Increment 1 (2026-07-02, docs/worker-prompts/documents-category-collapse.md)
 *
 * The historical `category` field on DocumentType overlaps with the newer
 * `pattern` field (e.g. category "work-order" and pattern "RN"/"RABOTEN-NALOG"
 * both identify a work order today). The approved target model collapses
 * `category` down to just `material` / `non-material`, with `pattern` (plus
 * `subCategory`/`subType`) carrying everything else.
 *
 * Increment 1 is BEHAVIOR-PRESERVING: every site that branched on the old
 * category values is converted to these dual-read helpers, which check
 * `pattern` FIRST and fall back to `category`. Since every document today
 * still carries both fields, this changes nothing visible yet — it just
 * moves the dispatch logic onto `pattern` so a later increment (Inc 3) can
 * safely shrink the `category` enum without breaking routing/sidebars/RBAC.
 *
 * Do not remove the category fallback until Inc 3 (after the data migration
 * that guarantees every relevant document carries the correct `pattern`).
 */

export const isRabotenNalog = (doc: {
  pattern?: string | null;
  category?: string;
}): boolean => {
  return doc.pattern === "RN" || doc.pattern === "RN-PROST" || doc.pattern === "RABOTEN-NALOG" || doc.category === "work-order";
};

export const isPlanDoc = (doc: {
  pattern?: string | null;
  category?: string;
}): boolean => {
  return (
    doc.pattern === "PLAN" ||
    ["planning", "plan-sales", "plan-procurement", "plan-production"].includes(doc.category ?? "")
  );
};
